import React from 'react';

import PropTypes from 'prop-types';

import Divider from '@adsk/alloy-react-divider';
import { variantSwitch } from '@adsk/alloy-react-helpers';
import theme, {
  stylePropType,
  StylableComponent,
} from '@adsk/alloy-react-theme';

import { BannerVariant, BANNER_VARIANTS } from './consts';

type BannerDividerProps = StylableComponent<HTMLHRElement> & {
  variant?: BannerVariant;
};

const BannerDivider = ({
  style,
  className,
  variant = BANNER_VARIANTS.PRIMARY,
  ...props
}: BannerDividerProps) => {
  return (
    <Divider
      variant={Divider.VARIANTS.VERTICAL}
      {...props}
      className={className}
      style={[
        {
          height: 32,
          margin: `0 ${theme.spacing.XS}px`,
          alignSelf: 'center',
        },

        variantSwitch({
          statement: variant,
          variants: {
            [BANNER_VARIANTS.PRIMARY]: {
              backgroundColor:
                theme.tokens.colors.background.information.subtle.value,
            },
            [BANNER_VARIANTS.SUCCESS]: {
              backgroundColor:
                theme.tokens.colors.background.success.subtle.value,
            },
            [BANNER_VARIANTS.WARNING]: {
              backgroundColor:
                theme.tokens.colors.background.warning.subtle.value,
            },
            [BANNER_VARIANTS.ERROR]: {
              backgroundColor:
                theme.tokens.colors.background.error.subtle.value,
            },
          },
        }),
        style,
      ]}
    />
  );
};

BannerDivider.displayName = 'BannerDivider';

BannerDivider.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** The banner variant */
  variant: PropTypes.oneOf(Object.values(BANNER_VARIANTS)),
};

export default BannerDivider;
